module.exports = __webpack_public_path__ + "img/tolback.040c57dc.png";